import { useContext, useEffect, useRef, useState } from "react";
import { DasboardContext } from "../../context/dashboard-context";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import AlarmTable from "../../components/AlarmTable/AlarmTable";
import "./style.css";

const LIMIT = 20;

const Alarms = () => {
  const [tableData, setTableData] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [hasQueried, setHasQueried] = useState(false);
  const [skip, setSkip] = useState(0);
  const observerRef = useRef();

  const { bedData, userInfo, sidebarOpen } = useContext(DasboardContext);

  const tableTD = [
    "Sıra No",
    "Saat Dilimi",
    "Süit Adı",
    "Oda Adı",
    "Olay Türü",
    "Cihaz Id",
    "Aranma Sayısı",
    "Teyit Durumu",
    "Açıklama",
    "Alarm Senaryosu",
    "İşlemi Yapan Kullanıcı",
    "Otomatik Yanıt",
  ];

  const getAlarmLogs = async (append = false) => {
    if (!startDate || !endDate) return;

    setLoading(true);
    try {
      const params = new URLSearchParams({
        start: startDate,
        end: endDate,
        skip: String(append ? skip : 0),
        limit: String(LIMIT),
        resolved: "true",
      });

      const res = await fetch(`https://app.vivasmartcare.com/api/alarm-logs?${params}`);
      const result = await res.json();

      const offset = append ? skip : 0;
      const withRowNo = (result.data || []).map((row, idx) => ({
        ...row,
        __rowNo: offset + idx + 1,
      }));

      if (append) {
        setTableData((prev) => [...prev, ...withRowNo]);
        setSkip((prev) => prev + result.data.length);
      } else {
        setTableData(withRowNo);
        setSkip(result.data.length);
      }

      setHasMore(result.hasMore);
      setHasQueried(true);
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = () => {
    setTableData([]);
    setSkip(0);
    setHasQueried(false);
    getAlarmLogs(false);
  };

  useEffect(() => {
    if (loading) return;
    if (!hasMore) return;
    if (!observerRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          getAlarmLogs(true);
        }
      },
      { threshold: 1.0 }
    );

    observer.observe(observerRef.current);

    return () => observer.disconnect();
  }, [loading, hasMore, startDate, endDate]);

  return (
    <>
      <Breadcrumb />
      <div
        className={`alarms-wrapper component-wrapper ${
          sidebarOpen ? "" : "close"
        }`}
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="date-filter">
          <label>
            Başlangıç Tarihi:
            <input
              type="datetime-local"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </label>
          <label>
            Bitiş Tarihi:
            <input
              type="datetime-local"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </label>
          <button
            onClick={handleFilter}
            disabled={!startDate || !endDate || loading}
            style={{
              opacity: !startDate || !endDate ? 0.6 : 1,
              cursor: !startDate || !endDate ? "not-allowed" : "pointer",
            }}
          >
            {loading && !tableData.length ? "Yükleniyor..." : "Filtrele"}
          </button>
        </div>

        {loading && tableData.length === 0 && (
          <p style={{ textAlign: "center", marginTop: 20 }}>
            Veriler yükleniyor...
          </p>
        )}

        {tableData.length > 0 ? (
          <>
            <AlarmTable
              key={`${startDate}-${endDate}`}
              tableTD={tableTD}
              tableData={tableData}
              bedData={bedData}
              userInfo={userInfo}
            />

            <div ref={observerRef} style={{ height: 40, textAlign: "center" }}>
              {loading && hasMore && <p>Yükleniyor...</p>}
              {!loading && !hasMore && hasQueried && (
                <p>Tüm veriler yüklendi.</p>
              )}
            </div>
          </>
        ) : (
          hasQueried &&
          !loading &&
          startDate &&
          endDate && (
            <p style={{ textAlign: "center", marginTop: 20 }}>
              📭 Bu tarih aralığında teyit edilmiş alarm bulunamadı.
            </p>
          )
        )}
      </div>
    </>
  );
};

export default Alarms;
